// extracted by mini-css-extract-plugin
module.exports = {"disable-scroll":"mobileheader_disable-scroll__2cUg1","dropdown":"mobileheader_dropdown__3R8tT"};